// NOTE: Dependencies: jQuery, Defiant

(function($) {
	$.fn.videoFocusPlay = function(options) {

		const $context = $(this);

		// check is dom element is defined
		if (!this.length) {
			return false;
		}

		// Default settings are set here.
		var settings = $.extend({
			$window: $(window),
			$body: $('body'), 
			video: $('.video-focus-play'), 
		}, options);

		// These are all the methods available for the plugin.
		var methods = {};

		methods.setCurrentSettings = function() {	
			var currentSettings = $context.data();

			if (!$.isEmptyObject(currentSettings)) {
				$context.data($.extend({}, settings, currentSettings));
			} else {
				$context.data(settings);
			}

			// Initialize item.
			$context.data('initialized', true);		
		};

		methods.initContext = function() {
			methods.setCurrentSettings();
		};

		methods.IsInView = function(window, element) {
			var window = window.get(0);
			const scroll = window.scrollY || window.pageYOffset
				const boundsTop = element.getBoundingClientRect().top + scroll

				const viewport = {
					top: scroll,
					bottom: scroll + window.innerHeight,
				}
				
				const bounds = {
					top: boundsTop,
					bottom: boundsTop + element.clientHeight,
				}
				
				return ( bounds.bottom >= viewport.top && bounds.bottom <= viewport.bottom ) 
					|| ( bounds.top <= viewport.bottom && bounds.top >= viewport.top );
		};

		// Bind events
		methods.events = function() {
			
			$context.each(function() {
				var $this = $(this);

				if (methods.IsInView($(window), $this.get(0))) {
					$this.get(0).play();
				} else {
					$this.get(0).pause();
				}
			});
		};
		
		// Filter each function.
		methods.filterEach = function() {
			return !$(this).data('initialized');
		};

		// Methods to run inside loop.
			
		// NOTE: Method you'd like initialized on a per context basis.
		methods.initContext($(this));

		// Run once methods when jquery plugin is called.
		methods.events(this);

		window.addEventListener('scroll', function (e) {
			methods.events(this);
		});
	};

	if ($('.video-focus-play').length) {
		$('.video-focus-play').videoFocusPlay();
	}

}(jQuery));
